import { BaSeIcon } from '@base/react';
import { formatDateToBR } from '../../utils/time';
import React from 'react';
import {
  FaCopy,
  FaPen,
  FaRegCheckCircle,
  FaTrash,
  FaCheckCircle,
} from 'react-icons/fa';
import { AiFillExclamationCircle } from 'react-icons/ai';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Spinner from 'react-spinner-material';
import styles from './styles.module.scss';
import { PaginationAdmin } from './PaginationAdmin';
import { formatDefaultValueSelect, numberLocale } from '../../utils/mask';
import { TableContainer } from '@material-ui/core';

export function TableAdmin({
  data,
  columns,
  isLoading,
  lineColor = '#FFFFFF',
  tableColor = '#0061C6',
  handleStateClick = null,
  handleEditClick = null,
  handleCopyClick = null,
  handleDeleteClick = null,
  handleVinculoClick = null,
  sentEntireObjectToEdit = false,
  sentEntireObjectToCopy = false,
  handleOrderClick = () => {},
  pagination = true,
  paginationFilters,
  linesPerPageFilters = 10,
  totalPages,
  onLinesPerPageChange,
  onPagePreviousChange,
  onPageNextChange,
  onInputPageChange,
  onKeyPressChange,
  columnAction = 'status',
  propertyColumnStatus = 'status',
}) {
  const dataContent = data?.content ?? data ?? [];

  const renderActions = (column, row, index) => {
    let iconProperties;

    if (propertyColumnStatus === 'status') {
      const rowStatus = row.status === 'APROVADO' ? 'APROVADO' : 'ATIVO';
      iconProperties = {
        title: row.status === rowStatus ? 'Desaprovar' : 'Aprovar',
        color: row.status === rowStatus ? '#0061C6' : '#FF0000',
      };
    } else {
      iconProperties = {
        title: !!row[propertyColumnStatus] ? 'Desaprovar' : 'Aprovar',
        color: !!row[propertyColumnStatus] ? '#0061C6' : '#FF0000',
      };
    }

    return (
      <TableCell
        width={column.minWidth}
        align={column.align}
        style={column?.columnStyle}
      >
        <div className={styles.itensActions}>
          {!!handleVinculoClick ? (
            !row.pendente ? (
              <FaCheckCircle
                size={25}
                color="#66BD91"
                onClick={() => handleVinculoClick(row)}
              />
            ) : (
              <AiFillExclamationCircle
                size={25}
                color="#F6E566"
                onClick={() => handleVinculoClick(row)}
              />
            )
          ) : (
            ''
          )}
          {!!handleStateClick && (
            <FaRegCheckCircle
              size={25}
              title={iconProperties?.title}
              color={iconProperties?.color}
              onClick={() => handleStateClick(row)}
            />
          )}

          {!!handleEditClick && (
            <FaPen
              title="Editar"
              color="#6C6C6C"
              onClick={() =>
                handleEditClick(sentEntireObjectToEdit ? row : row.id)
              }
              size={21}
            />
          )}

          {!!handleCopyClick && (
            <FaCopy
              title="Copiar"
              color="#6C6C6C"
              onClick={() =>
                handleCopyClick(sentEntireObjectToCopy ? row : row?.id)
              }
              size={21}
            />
          )}

          {!!handleDeleteClick && (
            <FaTrash
              title="Excluir"
              color="#6C6C6C"
              onClick={() => handleDeleteClick(row.id)}
              size={21}
            />
          )}
        </div>
      </TableCell>
    );
  };

  const renderDefault = (value, column, index) => {
    return (
      <TableCell align={column.align}>
        <div
          className={
            column.subfield === 'nomeAcao' ? styles.textTableServicos : ''
          }
          style={column?.columnStyle}
        >
          {value}
        </div>
      </TableCell>
    );
  };

  const renderIsTestadorBeta = (value) => {
    let isBeta = '';
    if (value) {
      isBeta = 'Sim';
    } else {
      isBeta = 'Não';
    }
    return isBeta;
  };

  const orderByProjetoAcoes = (order) =>
    order === 'uf.sigla' ? 'uf' : order === 'acoes.nomeAcao' ? 'id' : order;

  return (
    <>
      {isLoading && (
        <div className={styles.spinnerCenter}>
          <Spinner radius={80} color={'#0061C6'} stroke={2} visible={true} />
          <p>Carregando...</p>
        </div>
      )}
      <div className={styles.tableWrapper}>
        {!isLoading && (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow style={{ verticalAlign: 'middle !important' }}>
                  {columns.map((column, index) => {
                    const nameIcon = !!column.subfield
                      ? `${column.field}.${column.subfield}`
                      : column.field;

                    const orderByCollumn = column?.orderBy || column?.id;

                    return (
                      <TableCell
                        className={styles.tableBorder}
                        align={column?.align}
                        style={{
                          minWidth: column.minWidth,
                          borderColor: tableColor,
                          ...column?.cellStyle,
                        }}
                      >
                        <div className={styles.tableCellContainer}>
                          <p
                            className={styles.titleTable}
                            style={{ color: tableColor }}
                          >
                            {column.label}
                          </p>
                          {column.id !== columnAction && (
                            <BaSeIcon
                              name={
                                paginationFilters?.orderBy ===
                                  orderByProjetoAcoes(nameIcon) &&
                                paginationFilters?.direction === 'DESC'
                                  ? 'angle-up'
                                  : 'angle-down'
                              }
                              color={tableColor}
                              size={24}
                              description="Botão de ordenação"
                              onClick={() =>
                                handleOrderClick({
                                  orderBy: orderByCollumn,
                                  direction:
                                    paginationFilters?.direction === 'ASC'
                                      ? 'DESC'
                                      : 'ASC',
                                })
                              }
                            />
                          )}
                        </div>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {!dataContent.length ? (
                  <TableRow style={{ backgroundColor: '#FFFF' }}>
                    <TableCell align={'center'} colSpan={columns?.length}>
                      <p className={styles.tableEmptyText}>
                        Não existem resultados para a sua busca
                      </p>
                    </TableCell>
                  </TableRow>
                ) : (
                  dataContent?.map((row, index) => (
                    <TableRow
                      style={{
                        backgroundColor: index % 2 === 0 ? '#fff' : lineColor,
                      }}
                      hover
                      tabIndex={-1}
                    >
                      {columns.map((column) => {
                        const { id } = column;
                        const value = row[id];

                        if (id === columnAction) {
                          return renderActions(column, row, index);
                        }

                        if (!!column?.handleField) {
                          if ((column.field === 'empreendedor' || column.field === 'administrador')) {
                            return !column?.returnAsObject
                                ? renderDefault(column?.handleField(value?.cnpj ?? value?.cpf), column, index)
                                : renderDefault(column?.handleField(value), column, index)
                          } else {
                            return renderDefault(column?.handleField(!!column?.returnCompleteRow ? row : value), column, index);
                          }
                        }

                        const finalValue = Array.isArray(value)
                          ? value
                              .map((elem) => elem.sigla || elem.nomeAcao)
                              .join('\r\n')
                          : (value?.sigla ||
                              value?.cpf ||
                              value?.nome ||
                              value?.descricao ||
                              value?.cnpj ||
                              value?.nomePratif) ??
                            row[id];

                        if (column.field === 'dataCriacao' || column.field === 'dataProximoEnvio') {
                          return renderDefault(formatDateToBR(value), column, index);
                        }

                        if (column.field === 'instrumento') {
                          return renderDefault(formatDefaultValueSelect(value), column, index);
                        }
                        
                        if (
                          column.field === 'total' &&
                          column.label === 'Quantidade'
                        ) {
                          return renderDefault(numberLocale(value), column, index);
                        }
                        if (column.field === 'treinamento') {
                          return renderDefault(renderIsTestadorBeta(value), column, index);}

                        return renderDefault(finalValue, column, index);
                      })}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {!!pagination && (
          <PaginationAdmin
            color={tableColor}
            linesPerPageFilters={linesPerPageFilters}
            linesPerPageOptions={[10, 25, 50, 100]}
            filterPageSelectors={paginationFilters?.page}
            totalPages={totalPages}
            filtersSelectedValues={paginationFilters?.page}
            onLinesPerPageChange={onLinesPerPageChange}
            onPagePreviousChange={onPagePreviousChange}
            onPageNextChange={onPageNextChange}
            onInputPageChange={onInputPageChange}
            onKeyPressChange={onKeyPressChange}
          />
        )}
      </div>
    </>
  );
}
